import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { StakingGuard } from "@modules/staking/staking-guard.service";
import { TRADE_TYPE } from "@models/trade-offer.model";
import { StakingHelperService } from "@modules/staking/domain/+state/utility/staking-helper.service";
import { StakingAmountValidationService } from "@modules/staking/domain/+state/utility/staking-amount-validation.service";
import { StakingSharedModule } from "@modules/staking/features/staking-shared.module";
import { StakingWidgetsModule } from "@modules/staking/staking-widgets.module";
import { StakingResolver } from "@modules/staking/staking.resolver";

const routes: Routes = [
	{
		path: "stake",
		outlet: "modal",
		loadChildren: () =>
			import("app/modules/staking/features/stake/stake-flow.module").then((m) => m.StakeFlowModule),
		canActivate: [StakingGuard],
		resolve: {
			stakeableId: StakingResolver
		},
		data: {
			flowType: TRADE_TYPE.STAKE
		}
	},
	{
		path: "unstake",
		outlet: "modal",
		loadChildren: () =>
			import("app/modules/staking/features/unstake/unstake-flow.module").then((m) => m.UnstakeFlowModule),
		canActivate: [StakingGuard],
		resolve: {
			stakeableId: StakingResolver
		},
		data: {
			flowType: TRADE_TYPE.UNSTAKE
		}
	},
	{
		path: "staking-rewards",
		outlet: "modal",
		loadChildren: () =>
			import("app/modules/staking/features/rewards/rewards-flow.module").then((m) => m.RewardsFlowModule),
		canActivate: [StakingGuard],
		resolve: {
			stakeableId: StakingResolver
		}
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes), StakingSharedModule, StakingWidgetsModule],
	declarations: [],
	exports: [],
	providers: [StakingHelperService, StakingAmountValidationService]
})
export class StakingModule {}
